import { render, staticRenderFns } from "./EditWithdraw.vue?vue&type=template&id=647c4fd3"
import script from "./EditWithdraw.vue?vue&type=script&lang=js"
export * from "./EditWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports